import  { useEffect } from 'react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styles from './EditorExtension_MyImage.module.css';
import { useCCContext } from '../CC/CCContext';
import { CC } from '../CC/CC';
import * as ccUtils from '../CC/utils';
//import { generateQuery, postWithCache } from '../CC/utils';

/*
const cssStringToObject = (cssString) => {
  return cssString.split(';').reduce((acc, style) => {
    if (style.trim()) {
      let [property, value] = style.split(':').map(str => str.trim());

      // Convert kebab-case to camelCase
      property = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

      // Handle numeric values
      if (!isNaN(value) && value.trim() !== '') {
        value = Number(value);
      }

      acc[property] = value;
    }
    return acc;
  }, {});
};
*/
export default Node.create({
  name: 'reactComponentMyImage',
  group: 'inline',
  inline: true,
  atom: true,
  addAttributes() {
    return {
      selected: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-selected') === 'true',
        renderHTML: (attributes) => ({
          'data-selected': attributes.selected
        }),
      },
      state: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-state'),
        renderHTML: (attributes) => ({
          'data-state': attributes.state
        }),
      },
      query: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-query'),
        renderHTML: (attributes) => ({
          'data-query': attributes.query
        }),
      },
      htmlStyle: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-html-style'),
        renderHTML: (attributes) => ({
          'data-html-style': attributes.htmlStyle
        }),
      },
      imageUrl: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-image-url'),
        renderHTML: (attributes) => ({
          'data-image-url': attributes.imageUrl
        }),
      },
      imageAlt: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-image-alt'),
        renderHTML: (attributes) => ({
          'data-image-alt': attributes.imageAlt
        }),
      },
      compClass: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-class'),
        renderHTML: (attributes) => ({
          'data-class': attributes.compClass
        }),
      },
    }
  },
  parseHTML() {
    return [{ tag: 'MyImage' }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['MyImage', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

const Component = (props) => {
  const ctx = useCCContext();
  const { setCc, setFirst, setSelectedRecord, clearSearch } = ctx;
  const { selected, updateAttributes } = props;
  const { state, htmlStyle, imageUrl, imageAlt, compClass } = props.node.attrs;
  //const componentRef = useRef({});

  useEffect(() => {
    const handleSelection = () => {
      updateAttributes({ selected: props.editor.isActive('reactComponentMyImage') });
    };
    props.editor.on('selectionUpdate', handleSelection);
    return () => {
      props.editor.off('selectionUpdate', handleSelection);
    };
  }, [props.editor, updateAttributes]);

  const handleClick = async (event) => {
    if (!props.editor.isEditable) {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.get('albumexternal')) {
        if (state) {
          window.open(`${window.location.origin}${window.location.pathname}?state=${state}`, '_blank');
        }
      } else {
        if (state) {
          try {
            //const defaultCCObj = new CC();
              let startUPCCObj = state ? await ccUtils.GetCCFromState(state.replace(/'/g, '"')) : new CC();
            //const startUPCCObj = ccUtils.deepMerge(defaultCCObj, JSON.parse(state));
            setCc(startUPCCObj);
            setSelectedRecord(null);
            setFirst(1);
            
          } catch (error) {
            console.error("Error parsing state:", error);
          }
        } else {
          clearSearch();
        }
        ctx.setViewMode('list');
        //WvW: should call showSearch / setAndKeepMainY here
      }
    }
  };

  const handleDoubleClick = (event) => {
    if (props.editor.isEditable) {
      event.stopPropagation();
      const { state, query, htmlStyle, imageUrl } = props.node.attrs;
      const customEvent = new CustomEvent('showInsertContentPopup', {
        detail: {
          extension: 'MyImage',
          props: { state, query, htmlStyle, imageUrl, imageAlt, compClass },
          pos: props.getPos(),
          node: props.node
        },
        bubbles: true,
        cancelable: true
      });
      event.target.dispatchEvent(customEvent);
    }
  };

  //console.log(htmlStyle);
  //console.log(JSON.stringify(cssStringToObject(htmlStyle)));

  return (
    <NodeViewWrapper as="span" className={`react-component ${selected ? 'selected' : ''}`}>
      <span
        className={styles.hyperlink}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        dangerouslySetInnerHTML={{
          __html: `<img src=${imageUrl} style="${htmlStyle}" alt="${imageAlt}" class="${compClass}" />`
        }}
      />
    </NodeViewWrapper>
  );
};
